export enum EmailReminderTriggerType {
  INSPECTION_NOT_STARTED = 'INSPECTION_NOT_STARTED',
  INSPECTION_COMPLETED = 'INSPECTION_COMPLETED',
  ALL_TIMES = 'ALL_TIMES',
}

export type ListAllEmailReminder = {
  globalEmailSettingId?: string;
  groupId?: string;
};
